/* eslint-disable react/no-danger */
/**
 * GovItems
 * 
 * @Author: Focci
 * @Date: 2023-08-09 14:52:35
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-09 14:52:35
 */

import Image from 'next/image'
import PropTypes from 'prop-types'

function toBrTag(v) {
  return String(v).replace(/\n/g, '<br />')
}

export default function GovItems({
  data = [],
  enter = false
}) {
  return data.map((item) => (
    <div key={item.alias} className="flex items-start">
      <div className="shrink-0 w-4 h-4 relative">
        {enter && (
          <Image
            unoptimized
            src={item.icon2x || ''}
            className="object-contain"
            width={20}
            height={20}
            alt={item.label_cn}
          />
        )}
      </div>
      <div className="flex-auto ml-2 flex flex-col">
        <b>{item.label}</b>
        <span
          className="text-meta"
          dangerouslySetInnerHTML={{ __html: toBrTag(item.value) }} 
        />
      </div>
    </div>
  ))
}

GovItems.propTypes = {
  data: PropTypes.array,
}
